import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';
export const getSingleCategoryFunc = createAsyncThunk(
    "getSingleCategory",
    async (id, thunkAPI) => {
        try {
            const response = await api.get(`dashboard/categories/${id}`);
            return response.data.data.category;
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }

    }
)

const getSingleCategorySlicer = createSlice({
    name: "getSingleCategory",
    initialState: {
        loading: false,
        data: [],
        error: null,
        apiErrors: {},
        successMessage: "",
    },
    reducer: {},
    extraReducers: (builder) => {
        builder.addCase(getSingleCategoryFunc.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.apiErrors = {};
        })
            .addCase(getSingleCategoryFunc.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.successMessage = action.payload?.message || "";

            })
            .addCase(getSingleCategoryFunc.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.apiErrors = action.payload?.errors || {};
            });
    }
})

export default getSingleCategorySlicer.reducer;